import React, { useState } from "react";
import { Card, CardContent, Typography, Button } from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import PlanModal from "./planModal";
const CurrentPlan = ({ data }) => {
  const [open, setOpen] = useState(false);
  if (!data) return null;

  const { plan, startedOn, duration } = data;

  const handleEdit = () => {
    setOpen(true);
  };

  return (
    <Card>
      <PlanModal />
      <PlanModal
        open={open}
        onClose={() => setOpen(false)}
        // initialData={profile}
        // onSubmit={handleSubmit}
      />
      <CardContent>
        <Button
          style={{
            background: "#fff",
            marginLeft: "auto",
            width: "100px",
            display: "flex",
          }}
          startIcon={""}
          onClick={handleEdit}
        >
          Edit
        </Button>
        <div className="row">
          <div className="col-6">
            <Typography variant="h6">Current Plan</Typography>
            <Typography>Plan Name: {plan.name}</Typography>
            {/* <Typography>Status: {plan.status}</Typography> */}
            <Typography>
              Start Date: {new Date(startedOn).toLocaleDateString()}
            </Typography>
            <Typography>Duration: {duration}</Typography>
            <Typography>Amount: ₹{plan.prices[duration]}</Typography>
          </div>
          <div className="col-6">
            <Typography>Features:</Typography>
            <ul>
              {plan.features?.map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CurrentPlan;
